import { TIPS_ARM } from '../common/constants/tips';
import { useTipsStore } from '../stores/tipsStore';

export function useTipsArm(): void {
  const store = useTipsStore();

  if (import.meta.client && store.isOffered === null) {
    const { getVariation } = useGrowthBook();
    store.isOffered = getVariation<unknown>(EXPERIMENTS.THANKYOU_TIPS, TIPS_ARM.CONTROL) === TIPS_ARM.A;
  }
}
